import React, { Component } from 'react';
import { Provider } from 'react-redux';
import EventsIndex from './index';
import { createStore } from '../../../stores/eventsIndexStore';

class EventsIndexRoot extends Component {
  constructor(props) {
    super(props);
    this.store = createStore({ ...this.props, data: [] });
  }

  render() {
    return (
      <Provider store={this.store}>
        <EventsIndex />
      </Provider>
    );
  }
}

export default EventsIndexRoot;
